import React, { useState } from "react";
import { Play } from "lucide-react";
import { media, translations } from "../mock";
import { useLang } from "../i18n/LanguageContext";
import VideoDialog from "./VideoDialog";
import useReveal from "../hooks/useReveal";

export default function PromoVideo() {
  const [open, setOpen] = useState(false);
  const { ref, visible } = useReveal();
  const { lang } = useLang();
  const p = translations[lang].promo;

  return (
    <section className="py-24 md:py-28 bg-slate-50">
      <div className="mx-auto max-w-5xl px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-sm font-bold uppercase tracking-widest text-cblue">{p.eyebrow}</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-extrabold text-navy leading-tight">{p.title}</h2>
          <p className="mt-4 text-slate-600">{p.subtitle}</p>
        </div>
        <div ref={ref} className={`mt-12 reveal ${visible ? "is-visible" : ""}`}>
          <button onClick={() => setOpen(true)} aria-label="Play promo video"
            className="group relative block w-full overflow-hidden rounded-[2rem] device-shadow focus:outline-none focus:ring-4 focus:ring-cblue/30">
            {media.promoPoster ? (
              <img src={media.promoPoster} alt="CMED.AI promo" className="w-full h-[300px] md:h-[460px] object-cover transition-transform duration-700 group-hover:scale-105" />
            ) : (
              <video src={`${media.promoVideo}#t=0.5`} muted playsInline preload="metadata" className="w-full h-[300px] md:h-[460px] object-cover bg-slate-900" />
            )}
            <span className="absolute inset-0 bg-navy/40 transition-colors group-hover:bg-navy/50" />
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="grid h-20 w-20 place-items-center rounded-full bg-white/95 shadow-xl transition-transform duration-300 group-hover:scale-110"><Play className="h-8 w-8 text-navy fill-navy ml-1" /></span>
            </span>
          </button>
        </div>
      </div>
      <VideoDialog videoUrl={media.promoVideo} open={open} onOpenChange={setOpen} />
    </section>
  );
}
